import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { DataAction } from '../../../types/dataAction.type';

type FetchIosAppNameActionPayload = { iosAppName: string };

const FETCH_IOS_APP_NAME_NAMESPACE = 'FETCH_IOS_APP_NAME' as const;

const FetchIosAppName = new ReduxAsyncAction<typeof FETCH_IOS_APP_NAME_NAMESPACE, string, FetchIosAppNameActionPayload>(
  FETCH_IOS_APP_NAME_NAMESPACE
);

FetchIosAppName.registerRequest(async (appId: string) => {
  const appIdWithoutIdPrefix = appId.slice(2);

  const queryParameters = { id: appIdWithoutIdPrefix, country: 'no' };

  const queryString = new URLSearchParams(queryParameters).toString();

  const response = await fetch(`https://itunes.apple.com/lookup?${queryString}`, {
    method: 'POST',
  });

  const data = await response.json();

  const iosAppName = data?.results?.[0]?.trackName;

  return { iosAppName };
});

export const FETCH_IOS_APP_NAME = FetchIosAppName.actionNamespaceConstants;

export const fetchIosAppName = FetchIosAppName.request;

export type FetchIosAppNameResponseAction = DataAction<typeof FETCH_IOS_APP_NAME.response, FetchIosAppNameActionPayload>;
